// Task-type (use-case) topics, not industry verticals -- deliberately replaces the
// earlier Federal-Reserve-flavored topic set (Monetary Policy, Financial Stability,
// etc.), which was leftover content from a different, earlier product and shared
// almost no task-structure overlap with what a real learner practices prompting on.
// Grounded in real usage data (OpenAI/NBER "How People Use ChatGPT" Sept 2025;
// Anthropic Economic Index Jan/Mar 2026) and how live products (DeepLearning.AI,
// Google Prompting Essentials, Anthropic's own tutorial, Codecademy, Scrimba)
// structure applied practice -- see memory.md 2026-08-26 for full citations.
//
// `icon` is a LucideIcon name key (see components/LucideIcon.tsx's iconMap), not
// an emoji -- render with <LucideIcon name={topic.icon} />, never as raw text.
export const TOPICS = [
  {
    id: 'basic-prompt-engineering',
    name: 'Basic Prompt Engineering',
    description: '12 fundamental challenges covering prompt engineering basics',
    icon: 'topic-basic-prompt-engineering'
  },
  {
    id: 'writing-editing',
    name: 'Writing & Editing',
    description: 'Drafting and revising real text -- the single largest work use case for AI',
    icon: 'topic-writing-editing'
  },
  {
    id: 'summarizing-research',
    name: 'Summarizing & Research Synthesis',
    description: 'Condensing documents and synthesizing information accurately',
    icon: 'topic-summarizing-research'
  },
  {
    id: 'data-analysis',
    name: 'Data Analysis & Structured Output',
    description: 'Prompting for structured analysis, tables, and reliable formatted output',
    icon: 'topic-data-analysis'
  },
  {
    id: 'coding-debugging',
    name: 'Coding & Debugging Assistance',
    description: 'Prompting an AI to write, review, and fix real code',
    icon: 'topic-coding-debugging'
  },
  {
    id: 'tutoring-explaining',
    name: 'Tutoring & Explaining Concepts',
    description: 'Prompts that get an AI to teach a concept clearly, at the right level',
    icon: 'topic-tutoring-explaining'
  },
  {
    id: 'customer-communication',
    name: 'Customer & Client Communication',
    description: 'Drafting replies and messages for real customer- and client-facing scenarios',
    icon: 'topic-customer-communication'
  },
  {
    id: 'planning-decisions',
    name: 'Planning & Decision Support',
    description: 'Using AI for how-to guidance and comparing real options before deciding',
    icon: 'topic-planning-decisions'
  },
  {
    id: 'creative-ideation',
    name: 'Creative & Content Ideation',
    description: 'Brainstorming and shaping creative ideas with an AI collaborator',
    icon: 'topic-creative-ideation'
  },
  {
    id: 'agent-design',
    name: 'Designing AI Agents & Workflows',
    description: 'Conceptual practice for agent frameworks -- system prompts, orchestration choices, and spotting workflow bugs before you write real LangChain/LangGraph/CrewAI code',
    icon: 'topic-agent-design'
  }
];
